import { useState } from "react";
import { Color } from "utils/theme";
import { ReactComponent as HefringShield } from "assets/hefring-shield.svg";
import FileTree from "components/file-tree";
import TripsDownload from "components/trips-download";
import { useTranslation } from "react-i18next";
import { LanguageSelection } from "screens/settings/components/language-selection";

export default function AppDownload() {
  const { t } = useTranslation();

  const TabNavigation = [
    {
      title: t("file_download.tab_titles.trips"),
      key: "trips_download",
      content: TripsDownload,
    },
    {
      title: t("file_download.tab_titles.raw"),
      key: "raw_file_download",
      content: FileTree,
    },
  ];

  const [tab, setTab] = useState(TabNavigation[0].key);

  const SelectedTab = TabNavigation.find((t) => t.key === tab);

  return (
    <section className="h-screen overflow-hidden">
      <div
        className="px-4 w-full py-3 flex flex-col sm:flex-row sm:items-center justify-between border-b"
        style={{ borderColor: Color.Primary[800] }}
      >
        <span className="flex items-center space-x-2">
          <HefringShield className="h-7" />
          <h2 className="text-2xl font-medium">{t("file_download.title")}</h2>
        </span>
        <LanguageSelection />
      </div>
      <div className="h-full overflow-hidden flex flex-col md:flex-row">
        <div
          className="flex shrink-0 flex-row md:flex-col w-full md:w-fit h-fit md:h-full overflow-auto py-3 md:p-3 space-x-2 md:space-x-0 md:space-y-3 border-r"
          style={{
            borderColor: Color.Primary[800],
          }}
        >
          {TabNavigation.map((t) => {
            const isSelected = t.key === tab;

            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                className="rounded-md text-base w-fit md:w-full flex items-center justify-start px-5 py-3 md:min-w-[150px] lg:min-w-[200px]"
                style={{
                  background: isSelected ? Color.Primary[700] : "transparent",
                  color: isSelected ? Color.White : Color.Primary[500],
                }}
              >
                <p className="font-medium whitespace-nowrap">{t.title}</p>
              </button>
            );
          })}
        </div>
        {SelectedTab && (
          <div className="overflow-auto flex-1 space-y-3 p-6 flex flex-col">
            <SelectedTab.content />
          </div>
        )}
      </div>
    </section>
  );
}
